/* video-background.js — SATHI patched 2026-08-12 (hero-video-fastplay v2)
   Broadcast original(minified)の可読リライト+直モード対応。
   直モード: <video-background>内に<video>が直接ある場合(トップ動画)は即配線・即再生。
   template モード: 従来通りIntersectionObserverで実体化(下層セクション用)。
   共通: muted明示(動的挿入時のautoplay拒否対策)+play()失敗時はcanplayリトライ+
   初回タップ/タッチで再生(省電力モード対策)。画面外pause/復帰playも従来通り。 */
(function () {
  'use strict';
  var TEMPLATE_SEL = '[data-video-template]';
  var LOADING_CLASS = 'is-loading';
  var ID_ATTR = 'data-video-id';
  if (customElements.get('video-background')) return;
  customElements.define('video-background', class extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.videoId = this.getAttribute(ID_ATTR);
      this.videoTemplate = this.querySelector(TEMPLATE_SEL);
      this.video = this.querySelector('video'); // direct-embed mode (hero)
      this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this);
      if (!this.videoId) return;
      if (this.video) {
        this.startPlayback();
      } else if (this.videoTemplate) {
        this.renderVideo();
      }
    }
    powerSaverVideoPlay() {
      if (this.video && this.videoInView !== false && this.video.paused) {
        var p = this.video.play();
        if (p !== undefined) p.catch(function () {});
      }
    }
    startPlayback() {
      var self = this;
      this.videoInView = true;
      this.video.muted = true;
      if (this.video.preload !== 'auto') this.video.preload = 'auto';
      this.classList.remove(LOADING_CLASS);
      this.observeVideoPlayToggle();
      var attempt = this.video.play();
      if (attempt !== undefined) {
        attempt.then(function () {}).catch(function (err) {
          if (err && err.name === 'AbortError') return; // paused by visibility toggle, not an autoplay block
          var retry = function () {
            if (self.videoInView !== false && self.video.paused) self.video.play().catch(function () {});
          };
          if (self.video.readyState >= 3) retry();
          else self.video.addEventListener('canplay', retry, { once: true });
          document.addEventListener('click', self.powerSaverVideoPlay, { passive: true, once: true });
          document.addEventListener('touchstart', self.powerSaverVideoPlay, { passive: true, once: true });
        });
      }
    }
    renderVideo() {
      var self = this;
      this.videoTemplateObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          self.innerHTML = self.videoTemplate.innerHTML;
          self.video = self.querySelector('video');
          self.startPlayback();
          observer.unobserve(entry.target);
        });
      }, { root: null, rootMargin: '300px', threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
      this.videoTemplateObserver.observe(this);
    }
    observeVideoPlayToggle() {
      var self = this;
      if (!this.video) return;
      this.videoPlayObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var visible = entry.isIntersecting;
          self.videoInView = visible;
          if (visible && typeof self.video.play === 'function') {
            var p = self.video.play();
            if (p !== undefined) p.then(function () {}).catch(function () {});
          }
          if (!visible && typeof self.video.pause === 'function') self.video.pause();
        });
      }, { rootMargin: '0px', threshold: [0, 1] });
      this.videoPlayObserver.observe(this.video);
    }
    disconnectedCallback() {
      if (this.videoTemplateObserver) this.videoTemplateObserver.disconnect();
      if (this.videoPlayObserver) this.videoPlayObserver.disconnect();
      if (this.videoId) {
        document.removeEventListener('click', this.powerSaverVideoPlay);
        document.removeEventListener('touchstart', this.powerSaverVideoPlay);
      }
    }
  });
})();
